import { useMemo } from 'react';
import useUserInfo from 'campaigns-lib/hooks/useUserInfo';
import CustomCampaignEditPanel from './CustomCampaignEditPanel';
import I18n from 'I18n';
import { campaignFields } from '../../constants/campaignFieldsForEditing';
import { jsx as _jsx } from "react/jsx-runtime";
export default function CampaignEditPanel(props) {
  const {
    loading,
    data
  } = useUserInfo();
  const updatedCampaign = useMemo(() => props.use === 'clone' && props.campaign ? Object.assign({}, props.campaign, {
    [campaignFields.DISPLAY_NAME]: I18n.text('campaignsLib.campaignEditPanel.cloneDefaultName', {
      existingCampaignName: props.campaign[campaignFields.DISPLAY_NAME]
    })
  }) : props.campaign, [props.campaign, props.use]);
  if (loading || !data) {
    return null;
  }
  return /*#__PURE__*/_jsx(CustomCampaignEditPanel, {
    use: props.use,
    campaign: updatedCampaign,
    onClose: props.onClose,
    appName: props.appName,
    screen: props.screen,
    supportedAssets: props.supportedAssets,
    associatedUnsupportedAssets: props.associatedUnsupportedAssets,
    objectBuilderUiProps: props.objectBuilderUiProps,
    assetObjectType: props.assetObjectType
  });
}